<template>
<div>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-9">
                        <div class="font-weight-bold body-1">
                            Resultados de la evaluación
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="9" class="py-0" >
                        <v-row justify="space-between">
                            <v-col cols="9">
                                <span>
                                    A continuación se muestran los resultados de la evaluación realizada por {{evaluator}}
                                    a {{evaluated}}.
                                </span>
                            
                            </v-col>
                             <v-col class="text-right">
                                <div class="evaluation-answers-top-buttons">
                                    <iconButton :props="homeBtnData" class="mr-1"></iconButton>
                                    <iconButton :props="prevBtnData" class="mr-1"></iconButton>
                                    <iconButton :props="nextBtnData"></iconButton>
                                </div>
                            </v-col>
                        </v-row>
                        

                    </v-col>

                   
                    
                </v-row>

                <v-row justify="center">
                    <v-col cols="12" md="9" class="py-0">
                        <div class="evaluation-answers-summary-container mt-1">
                            <span>
                                Promedio general del evaluado
                            </span>
                            <span>
                                {{finalResult}}
                            </span>
                        </div>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col cols="12" md="9">
                        <div class="evaluation-answers-container">
                           <span class="evaluation-answers-title">
                                Aspectos evaluados en una escala de 1 a 5
                           </span>

                           
                            <div  v-for="(question, index) in questions" :key="index" class="mb-2">
                                <div class="evaluation-answers-sub-result my-1">
                                    <span class="mr-2">
                                        {{question.question}}
                                    </span>
                                    <div class="evaluation-answers-sub-result-value">
                                        <span>{{getResponseValue(question.id)}}</span>
                                    </div>
                                </div>
                                <div class="evaluation-answers-full-response-body">
                                        <span>
                                           {{getResponseText(question.id)}}
                                        </span>
                                </div>
                            </div>

                            <span class="evaluation-answers-title">
                                Comentarios generales
                            </span>
                            <div class="evaluation-answers-comments-container">
                                <span class="pre">
                                    {{comments}}
                                </span>
                            </div>
                           
                        </div>
                    </v-col>
                </v-row>

                <v-row  justify="center">
                    <v-col  cols="12" md="9" class="pt-0">
                        <span class="evaluation-answers-doc-rev-text">{{docRev}}</span>
                    </v-col>
                </v-row>

             
            </div>

              
        </template>
    </contentCard>
       
  </div>
</template>

<script>
// import Utils from '../../../helpers/Utils';
// import Utils from '../../../helpers/Utils';
export default {
    components: {
    },
	data(){
		return {
            docRev: 'GM-CLF-04 REV:04',
            id: this.$route.params.id,
            employeeId: this.$route.params.employeeId,
            indexEmployeeSelected: -1,
            evaluatedArray: [],
            rawData: {},
            loading: false,
            evaluator: '',
            evaluated: '',
            comments:'',
            finalResult:'',
          
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "Evaluations",	
                block: false,
                click: () => {}
            },

            homeBtnData: {
				hasTooltip:true,
                tooltip: 'Inicio',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-home-outline",
				to: "Evaluations",
				block: true,
                click: ()=>{}
            },
            prevBtnData: {
				hasTooltip:true,
                tooltip: 'Anterior',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-arrow-left",
				to: "",
				block: true,
                disabled:false,
                click: ()=>{this.prevItem()}
            },
            nextBtnData: {
				hasTooltip:true,
                tooltip: 'Siguiente',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-arrow-right",
				to: "",
				block: true,
                disabled:false,
                click: ()=>{this.nextItem()}
            },
            answers: [],
            questions: [ 
                {
                    "id": 1,
                    "question": "Conocimientos y habilidades: entrega de tareas",
                    "options": [
                        { "id": 1, "option": "Carece de conocimientos y habilidades para realizar las actividades propias del puesto", "value": 1 },
                        { "id": 2, "option": "CARECE DE CONOCIMIENTOS Y HABILIDADES PARA REALIZAR LAS ACTIVIDADES PROPIAS DE SU PUESTO, PERO PUEDE SER INSTRUIDO PARA REALIZARLAS.", "value": 2 },
                        { "id": 3, "option": "TIENE CONOCIMIENTOS Y HABILIDADES PARA REALIZAR LAS ACTIVIDADES PROPIAS DE SU PUESTO, AUNQUE MUESTRA ALGUNOS TIEMPOS MUERTOS, REQUIERE SEGUIR PRACTICANDO PARA MEJORAR TIEMPO Y CALIDAD.", "value": 3 },
                        { "id": 4, "option": "TIENE CONOCIMIENTOS Y HABILIDADES PARA REALIZAR LAS ACTIVIDADES PROPIAS DE SU PUESTO, LA CALIDAD Y TIEMPO EN QUE LO DESARROLLA ES MUY ACEPTABLE.", "value": 4 },
                        { "id": 5, "option": "TIENE CONOCIMIENTOS Y HABILIDADES PARA REALIZAR LAS ACTIVIDADES PROPIAS DE SU PUESTO Y PUEDE ENTRENAR A OTROS", "value": 5 }
                    ]
                },
                {
                    "id": 2,
                    "question": "TRABAJO EN EQUIPO: DISPONIBILIDAD",
                    "options": [
                        { "id": 1, "option": "NUNCA QUIERE COLABORAR CON OTROS PARA REALIZAR EL TRABAJO, NUNCA ESTA DISPUESTO A APOYAR EN ALGUNA ACTIVIDAD ADICIONAL", "value": 1 },
                        { "id": 2, "option": "SE LE NOTA INCOMODO CUANDO REQUIERE COLABORAR CON OTROS PARA REALIZAR EL TRABAJO, NO ACCEDE DE MANERA INMEDIATA A APOYAR EN ALGUNA ACTIVIDAD ADICIONAL.", "value": 2 },
                        { "id": 3, "option": "COLABORA CON OTROS PARA REALIZAR EL TRABAJO, AUNQUE NO ACCEDE DE MANERA INMEDIATA A APOYAR EN ALGUNA ACTIVIDAD ADICIONAL.", "value": 3 },
                        { "id": 4, "option": "COLABORA CON OTROS PARA REALIZAR EL TRABAJO SIN NINGÚN PROBLEMA, SIEMPRE ESTA DISPUESTO A APOYAR EN ALGUNA ACTIVIDAD ADICIONAL.", "value": 4 },
                        { "id": 5, "option": "APOYA Y RESPETA LAS ACTIVIDADES DE OTROS Y SE ESFUERZA PARA ALCANZAR LOS OBJETIVOS", "value": 5 }
                    ]
                },

                {
                    "id": 3,
                    "question": "CAPACIDAD DE ANÁLISIS: PROACTIVIDAD",
                    "options": [
                    {  "id": 1 ,"option": "NO MUESTRA CAPACIDAD PARA ANALIZAR LA INFORMACIÓN DISPONIBLE E INMEDIATA PROPIA DE SU PUESTO.", "value": 1},
                    {  "id": 2 ,"option": "MUESTRA CAPACIDAD DE ANÁLISIS, SIN EMBARGO MUCHAS VECES CARECE DE OBJETIVIDAD EN EL RESULTADO DE SU ANÁLISIS.", "value": 2},
                    {  "id": 3 ,"option": "MUESTRA CAPACIDAD DE ANÁLISIS SUFICIENTE, AUNQUE REQUIERE MAS OBJETIVIDAD EN EL RESULTADO DE SU ANÁLISIS.", "value": 3},
                    {  "id": 4 ,"option": "SU CAPACIDAD DE ANÁLISIS ES MUY CONFIABLE Y MUESTRA OBJETIVIDAD EN SUS CONCLUSIONES.", "value": 4},
                    {  "id": 5 ,"option": "SU CAPACIDAD DE ANÁLISIS ES MUY CONFIABLE PARA DETECTAR POSIBLES ERRORES Y TOMAR DECISIONES ADECUADAS. ATENCIÓN A CLIENTE/PROVEEDOR: COMUNICACIÓN *", "value": 5}
                ]
                }

                ,
                {
                    "id": 4,
                    "question": "ATENCIÓN A CLIENTE/PROVEEDOR: COMUNICACIÓN",
                    "options": [
                        { "id": 1, "option": "SE MUESTRA POCO AMABLE CUANDO EL CLIENTE/ PROVEEDOR LE REQUIERE ALGUNA CONSULTA. NO ATIENDE INMEDIATAMENTE SUS NECESIDADES.", "value": 1 },
                        { "id": 2, "option": "SE LIMITA A LA COMUNICACIÓN ABSOLUTAMENTE NECESARIA. ATIENDE LOS REQUERIMIENTOS DEL CLIENTE/PROVEEDOR PERO MUESTRA RETRASOS OCASIONALES EN EL SEGUIMIENTO A SUS NECESIDADES.", "value": 2 },
                        { "id": 3, "option": "SE MUESTRA AMABLE CON EL CLIENTE/PROVEEDOR, ATIENDE SUS NECESIDADES, PERO EL CLIENTE NO SE SIENTE SATISFECHO EN EL SEGUIMIENTO Y TIEMPO DE RESPUESTA.", "value": 3 },
                        { "id": 4, "option": "SE CARACTERIZA POR UN TRATO CALIDO Y RESPETUOSO HACIA EL CLIENTE/PROVEEDOR, LO CUAL AYUDA A MANTENER RELACIONES MUTUAMENTE BENEFICIOSAS.", "value": 4 },
                        { "id": 5, "option": "ATIENDE INMEDIATAMENTE LAS NECESIDADES DEL CLIENTE/PROVEEDOR Y DA SEGUIMIENTO A LO REQUERIDO.", "value": 5 }
                    ]
                }

                ,
                {
                    "id": 5,
                    "question": "RESPONSABILIDAD: ASISTENCIA Y PUNTUALIDAD",
                    "options": [
                        { "id": 1, "option": "SU TRABAJO SE VE AFECTADO DEBIDO A INASISTENCIAS CONSTANTES Y FALTA DE ATENCIÓN EN SUS ACTIVIDADES.", "value": 1 },
                        { "id": 2, "option": "SU TRABAJO SE VE AFECTADO DEBIDO A INASISTENCIAS OCASIONALES (NO JUSTIFICADAS), MUESTRA UNA FALTA DE ATENCION EN EL DESEMPEÑO DE SUS ACTIVIDADES.", "value": 2 },
                        { "id": 3, "option": "SU TRABAJO SE VE AFECTADO DEBIDO A RETRASOS OCASIONALES EN LA REALIZACIÓN DE SUS ACTIVIDADES, PERO EL GRUPO DE TRABAJO NO SE VE AFECTADO.", "value": 3 },
                        { "id": 4, "option": "SIEMPRE CUMPLE CON LA TOTALIDAD DE SUS TRABAJOS EN LAS FECHAS ACORDADAS, ES UN INTEGRANTE VALIOSO DEL GRUPO DE TRABAJO.", "value": 4 },
                        { "id": 5, "option": "SIEMPRE ENTREGA A TIEMPO SU TRABAJO Y MUESTRA UN 100% DE ASISTENCIA Y PUNTUALIDAD", "value": 5 }
                    ]
                },

                {
                    "id": 6,
                    "question": "BUENAS PRÁCTICAS: HIGIENE Y LIMPIEZA",
                    "options": [
                        { "id": 1, "option": "SU SALUD Y TRABAJO SE VE AFECTADO CONSTANTEMENTE DEBIDO A FALTA DE HIGIENE Y LIMPIEZA.", "value": 1 },
                        { "id": 2, "option": "SU SALUD Y TRABAJO SE VE AFECTADO OCASIONALMENTE DEBIDO A FALTA DE HIGIENE Y LIMPIEZA. MUESTRA UNA FALTA DE INTERES EN SU SALUD Y EL GRUPO DE TRABAJO SE VE AFECTADO.", "value": 2 },
                        { "id": 3, "option": "SU SALUD Y TRABAJO SE VE AFECTADO POCAS OCASIONES DEBIDO A FALTA DE HIGIENE Y LIMPIEZA, PERO EL GRUPO DE TRABAJO NO SE VE AFECTADO.", "value": 3 },
                        { "id": 4, "option": "CASI SIEMPRE CUMPLE CON LOS ESTANDARES DE HIGIENE Y LIMPIEZA, ES UN INTEGRANTE QUE CUIDA SU SALUD", "value": 4 },
                        { "id": 5, "option": "SIEMPRE CUMPLE CON LOS ESTANDARES DE HIGIENE Y LIMPIEZA, ES UN INTEGRANTE QUE CUIDA SU SALUD.", "value": 5 }
                    ]
                }
            ]
       
          
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.cancelBtnData.block = true;
            }
            else{
                this.cancelBtnData.block = false;
            }
        },
        method_handler(object){
			this[object.method_name](object.parameters)
		},
		validate () {
			return this.$refs.form.validate()
		},
        preparePrevNextActions(data, employeeId){
            this.evaluatedArray =  data.evaluated.filter((x) => x.answers != null);
            this.indexEmployeeSelected = this.evaluatedArray.findIndex((x) => x.employee.id == employeeId);
            this.prevBtnData.disabled = false;
            this.nextBtnData.disabled = false;
            if(this.indexEmployeeSelected == 0){
                this.prevBtnData.disabled = true;
            }
            if(this.indexEmployeeSelected + 1 == this.evaluatedArray.length)
            {
                this.nextBtnData.disabled = true;
            }
            
        },
        preparePage(data, employeeId){
            console.log(data,employeeId)
            this.evaluator = data.evaluator.name;
            const evaluatedSelected = data.evaluated.find((x) => x.employee.id == employeeId);
            this.evaluated = evaluatedSelected.employee.name;
            this.answers = evaluatedSelected.answers;
            this.comments = evaluatedSelected.comments??'';
            this.finalResult = this.getFinalResult(evaluatedSelected.answers);
            this.preparePrevNextActions(JSON.parse(JSON.stringify(data)), employeeId)
        },
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.evaluation.get(this.id)
                .then((response) => {
                    console.log(response);
                    // this.items.forEach((y) => {
                    //     y.valor = response.data[y.index]
                    // });
                    response.data.evaluated = response.data.evaluated.sort((a, b) =>{
                        if (a.employee.name < b.employee.name) {
                            return -1;
                        }
                        if (a.employee.name > b.employee.name) {
                            return 1;
                        }
                        return 0;}
                    );
                    console.log(response.data.evaluated)
                    this.rawData = response.data;
                    this.preparePage(JSON.parse(JSON.stringify(this.rawData)), this.employeeId)
                    
                    
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
		},
        prevItem()
        {
            console.log(this.indexEmployeeSelected)
            this.preparePage(this.rawData ,this.evaluatedArray[this.indexEmployeeSelected - 1].employee.id)
        },
        nextItem()
        {
            this.preparePage(this.rawData ,this.evaluatedArray[this.indexEmployeeSelected + 1].employee.id)
        },
        getFinalResult(answers)
        {
            let sum = 0;
            answers.forEach(item => {
                sum = sum + item.answer??0;
            });

            sum = (sum / 6).toFixed(1);

            let text = '';
            if(sum < 2)
                text = "Mínimo";
            else if(sum < 4)
                text = "Medio";
            else
                text = "Alto";

            return `${sum} (${text})`
        },
        getResponseValue(questionId)
        {
            const answer = this.answers.find((x) => x.question_id == questionId);
            if(answer == undefined)
                return 0;
            return answer.answer;
        },
        getResponseText(questionId)
        {
            const answer = this.answers.find((x) => x.question_id == questionId);
            const question = this.questions.find((x) => x.id == questionId);
            if(answer == undefined || question == undefined)
                return "-";

            const text = question.options.find((x) => x.id == answer.answer)?.option??"-";

            return text;
        },

        
    },
}
</script>

<style lang="scss">
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }


    .evaluation-answers{

        &-top-buttons{
            display: flex;
            justify-content: flex-end;
        }

        &-summary-container{
            display: flex;
            justify-content: space-between;
            border: 0.17rem solid #E572AA;
            padding: 0px 1.4rem 0px 1.4rem;
            color: #E572AA;
            font-weight: 600;
        }



        &-container{
            border: 0.1rem solid rgb(67, 66, 66);
            border-radius: 8px;
            padding: 1rem 1.4rem 1rem 1.4rem;
        }

        &-title{
            font-size: 0.9rem;
            font-weight: 500;
            color: black;

        }

        &-sub-result{
            display: flex;
            &-value{
                background-color: #E572AA;
                padding: 0 0.5rem 0 0.5rem;
                border-radius: 8px;
                color: #FFF;
                font-weight: 600;
            }
        }

        &-full-response-body{
            padding: 0.2rem 0.7rem 0.2rem 0.7rem;
            border: solid 1px #E572AA;
            border-radius: 8px;
            background-color: #F7F7F7;
            font-size: .85rem;
        }


        &-comments-container{
            padding: 0.2rem 0.7rem 0.2rem 0.7rem;
            border-radius: 8px;
            background-color: #F7F7F7;
        }

        &-doc-rev-text{
            font-size: small;
            color: gray;
            font-weight: 600;
        }
    }
    
    
</style> 